// extracted by mini-css-extract-plugin
export default {"wrapper":"MarketsToolbar_wrapper__K1lYG","active":"MarketsToolbar_active__OoWyY"};